const googleMapsCallback = "__googleMapsCallback",
  url = "https://maps.googleapis.com/maps/api/js?",
  apiKeyQuery = `key=${process.env.GOOGLE_MAPS_API_KEY || "AIzaSyDxqndWdIJyW9fozO2b7yxZnRqoRVxV_6g"}`,
  position = {
    lat: 51.436101,
    lng: 5.4913513,
  },
  position2 = {
    lat: 51.443,
    lng: 5.525,
  },
  mapOptions = {
    center: { lat: 51.440, lng: 5.505 },
    clickableIcons: false,
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    zoom: 13,
    mapId: '5c21da6cee60bcde2ac73125',
  },
  selectors = {
    mapsContainer: "googleMapsContainer",
    mapInfoContainer: ".js-google-maps-info-container",
    script: "script",
  };

function initMap() {
  const mapContainer = document.getElementById(selectors.mapsContainer),
    infoContainer = document.querySelector(selectors.mapInfoContainer),
    map = new google.maps.Map(mapContainer, mapOptions);

  new google.maps.marker.AdvancedMarkerElement({
    position: position,
    map: map,
  });

  new google.maps.marker.AdvancedMarkerElement({
    position: position2,
    map: map,
  });

  map.panBy(0, 0 - infoContainer.getBoundingClientRect().height);
}

class MapsConfigurator {
  constructor() {
    window[googleMapsCallback] = initMap;

    const script = document.createElement(selectors.script);

    script.src = `${url}${apiKeyQuery}&callback=${googleMapsCallback}&loading=async&libraries=marker&language=nl`;
    document.body.appendChild(script);
  }
}

function init() {
  return new MapsConfigurator();
}

init();

export default MapsConfigurator;
